import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaOrdemNomeModulo = (): TabelaColuna => ({
  Chave: 'ordemNomeModulo',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Ordem Nome Modulo</div>
})
